import * as React from "react";

const IconExpand: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="9" viewBox="0 0 16 9" fill="currentColor"><polygon fill="#666" points="8.699 .675 15.299 6.987 16 7.658 14.598 8.996 13.896 8.325 7.998 2.68 2.1 8.329 1.398 9 0 7.658 .701 6.987 7.297 .671 7.998 0" transform="matrix(1 0 0 -1 0 9)"/></svg>;
};

export default React.memo(IconExpand);
